import { remove } from "./remove.js";

export const pull = <T>(array: Array<T>, value: T): Array<T> =>
  remove(array, (test) => test === value);
